<mat-dialog-content>
  <lemon-dialog-header> Poista tilitapahtumat ja kirjaukset </lemon-dialog-header>

  <div class="dialog-content">
    <div style="background-color: #ffebee; border-left: 4px solid #f44336; padding: 12px 16px; margin-bottom: 20px; border-radius: 2px">
      <strong>Varoitus: Tätä toimintoa ei voi peruuttaa.</strong><br />
      Kaikki tilitapahtumat ja niistä luodut kirjaukset poistetaan pysyvästi IBAN:ille:
      <div style="font-family: monospace; font-size: 14px; margin-top: 8px; font-weight: bold">{{ data.iban }}</div>
    </div>

    <form>
      <div style="display: flex; gap: 16px; margin-bottom: 8px">
        <mat-form-field style="flex: 1">
          <mat-label>Alkaen</mat-label>
          <input matInput [matDatepicker]="startPicker" [formField]="lomake.start" autocomplete="off" />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          @if (onkoVirhe(lomake.start, 'required')) {
            <mat-error> Valitse alkupäivämäärä </mat-error>
          }
        </mat-form-field>

        <mat-form-field style="flex: 1">
          <mat-label>Päättyen</mat-label>
          <input matInput [matDatepicker]="endPicker" [formField]="lomake.end" autocomplete="off" />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
          @if (onkoVirhe(lomake.end, 'required')) {
            <mat-error> Valitse loppupäivämäärä </mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field style="width: 100%">
        <mat-label>Kirjoita IBAN vahvistaaksesi</mat-label>
        <input matInput [formField]="lomake.vahvistus" autocomplete="off" />
        @if (onkoVirhe(lomake.vahvistus, 'required')) {
          <mat-error> Kirjoita IBAN </mat-error>
        }
        @if (onkoVirhe(lomake.vahvistus, 'ibanMismatch')) {
          <mat-error> IBAN ei täsmää </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <app-secondary-button actionId="Peruuta" (click)="peruuta()">Peruuta</app-secondary-button>
  <app-primary-button actionId="Poista kaikki" (click)="poista()" [disabled]="!lomake().valid()">Poista kaikki</app-primary-button>
</mat-dialog-actions>
